import {
  GET_GOVT_ORDERS_FAILURE,
  GET_GOVT_ORDERS_REQUEST,
  GET_GOVT_ORDERS_SUCCESS,
} from "./types";

const initialState = {
  data: [],
  lastPage: 1,
  loading: false,
  error: null,
};

const GovtOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_GOVT_ORDERS_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_GOVT_ORDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload?.data?.data || [],
        lastPage: action.payload?.data?.last_page || 1,
      };
    case GET_GOVT_ORDERS_FAILURE:
      return { ...state, loading: false, error: "Failed to fetch" };
    default:
      return state;
  }
};

export default GovtOrderReducer;
